module.exports = __webpack_public_path__ + "6daacca06a04b837db182ad2f8793b9f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owl-item-types/furniture_icon.png
// module id = 1727
// module chunks = 0